import angular from 'angular';
import grid from 'angular-ui-grid';

import storageFilters from '../../components/filters/storage';

export class DocumentMovementsController {

  closeWindow: Function;

  data;
  options;
  grid;

  /*@ngInject*/
  constructor($scope, Storage, WindowService) {
    this.Storage = Storage;
    this.scope   = $scope;

    this.closeWindow = WindowService.delItem;
  }

  $onInit() {

    return this.Storage.loadMovements({documentId: this.data.document._id})
      .then((movements) => {
        this.options = {
          primaryKey: '_id',
          enableCellEdit: true,
          enableRowSelection: true,
          enableRowHeaderSelection: false,
          multiSelect: false,
          modifierKeysToMultiSelect: false,
          noUnselect: true,
          rowEditWaitInterval: -1,
          data: movements,
          onRegisterApi: (gridApi) => {
            this.grid = gridApi;

            this.grid.edit.on.afterCellEdit(this.scope, (rowEntity, colDef, newValue, oldValue) => {
              
              if(oldValue  == newValue) {
                return false;
              }

              return this.Storage.saveMovement(rowEntity)
                .then(() => {
                  this.grid.rowEdit.setRowsClean([rowEntity]);
                });
            });
          },
          columnDefs: [{
            displayName: '#',
            field: '_id',
            groupable: false,
            resizable: false,
            sortable: false,
            visible: false,
            width: 50
          }, {
            displayName: '#',
            field: 'active',
            sortable: false,
            resizable: false,
            width: 50,
            cellTemplate: '<div class="ui-grid-cell-contents" ng-bind-html="grid.getCellValue(row, col) | renderMovementStatus"></div>',
            cellEditableCondition: function(){ return false; }
          }, {
            displayName: 'Дата/Время',
            field: 'dtime',
            groupable: false,
            resizable: true,
            sortable: true,
            visible: true,
            width: 150,
            cellFilter: "date:'dd.MM.yy HH:mm'",
            sort: {
              direction: 'desc',
              priority: 100 
            },
            cellEditableCondition: function(){ return false; }
          }, {
            displayName: 'Товар',
            field: 'productId',
            groupable: true,
            resizable: true,
            sortable: true,
            visible: true,
            width: 150,
            cellFilter: 'renderProduct',
            cellEditableCondition: function(){ return false; }
          }, {
            displayName: 'Склад',
            field: 'storageId',
            visible: true,
            cellFilter: '',
            cellTemplate: '<div class="ui-grid-cell-contents" ng-bind-html="grid.getCellValue(row, col) | renderStorage"></div>',
            cellEditableCondition: function(){ return false; }
          }, {
            displayName: 'Кол-во',
            field: 'count',
            groupable: true,
            resizable: true,
            sortable: true,
            visible: true,
            width: 100,
          }, {
            displayName: 'Заказ',
            field: 'order',
            groupable: true,
            resizable: true,
            sortable: true,
            visible: true,
            width: 100,
            cellEditableCondition: function(){ return false; }
          }, {
            displayName: 'Комментарий',
            field: 'comment',
            groupable: false,
            resizable: false,
            sortable: false,
            visible: true,
          }]
        };
      });
  }

  close() {
    this.closeWindow(this.data.id);
  }
}

export default angular.module('storageApp.document.movments', [
    grid,
    grid + '.selection',
    grid + '.edit',
    grid + '.rowEdit',
    grid + '.saveState',
    grid + '.grouping',

    storageFilters
  ])
  .filter('renderMovementStatus', function($sce){
    'ngInject';

    return function (input) {
      return $sce.trustAsHtml('<span class="glyphicon glyphicon-' + (input ? 'ok-circle' : 'ban-circle') + '" title="' + (input ? 'Активен' : 'Отключен') + '" aria-hidden="true"></span>');
    };
  })
  .filter('renderProduct', function(Storage){
    'ngInject';

    return function (input) {
      return Storage.getProducts()
        .filter(product => {
          return input == product._id;
        })
        .map(product => {
          return product.name;
        })
        .shift();
    };
  })
  .component('documentMovements', {
    bindings: {data: '='},
    transclude: true,
    template: require('./document-movements.html'),
    controller: DocumentMovementsController
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/document-movements/document-movements.component.js